export default {
    orders: [],
    currentOrder: null,
    totalCount: 0,
    couriers: [],
    statusesCount: [],
    isLoading: false,

    selectedOrders: [],

    orderChanges: [],
    orderChangesTotal: 0,
    orderChangesLoading: false,

    printGroups: {},

    routes: [],
    routesCount: 0,
    routesLoading: false,
    routeCreating: false,

    routeStatusesCount: [],
    routeStatusesLoading: false,

    // Маркеры CDC-событий. Инкрементируются обработчиками Centrifugo, чтобы
    // страница диспетчера могла перезапросить агрегаты (счётчики статусов),
    // не подписываясь на сами события из composable из родительского App.vue.
    cdcOrderVersion: 0,
    cdcRouteVersion: 0,
    // Источник последнего обновления списка заказов (для сохранения выделения)
    ordersUpdateSource: null,

    orderListContext: {
        filters: {},
        tabIndex: 0,
        currentPage: 1,
        limit: 20,
        sortBy: 'delivered_date',
        sortDesc: false,
        divisionId: '',
        shiftOpenedAt: null,
    },

    // Активная выборка панели маршрутов. Нужна обработчику route_updated,
    // чтобы решать, добавлять ли новый маршрут (CDC-INSERT) в список.
    routeFilters: {
        division_id: null,
        start_date: null,
        end_date: null,
        status: null,
    },
}
